import { toast } from "react-toastify";

export const getBackendErrorMessage = (
    error,
    fallback = "Something went wrong. Please try again."
) => {
    const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.data?.message ||
        error?.message ||
        fallback;

    if (Array.isArray(message)) return message[0] || fallback;
    return message || fallback;
};

export const toastBackendError = (error, fallback) => {
    const message = getBackendErrorMessage(error, fallback);

    toast.error(message, {
        position: "top-right",
    });

    return message;
};
